// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ArrowDown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ArrowDown = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ArrowDown = _exports.ArrowDown = function ArrowDown(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M15.3434 11.7955L10.3758 16.7631C10.3268 16.812 10.268 16.851 10.2034 16.8779C10.1388 16.9049 10.0692 16.9192 9.99965 16.9192C9.93011 16.9192 9.86119 16.9049 9.7959 16.8779C9.73062 16.851 9.67248 16.812 9.62352 16.7631L4.65595 11.7955C4.44802 11.5876 4.44802 11.2505 4.65595 11.0426C4.86387 10.8346 5.20098 10.8346 5.40891 11.0426L9.46811 15.1017V3.61329C9.46811 3.3195 9.70655 3.08105 10.0003 3.08105C10.2941 3.08105 10.5326 3.3195 10.5326 3.61329V15.1017L14.5918 11.0426C14.7997 10.8346 15.1368 10.8346 15.3447 11.0426C15.5527 11.2505 15.5513 11.5876 15.3434 11.7955Z",
      fill: "#212B36"
    }));
  };
});
